module.exports = __webpack_public_path__ + "static/media/snake.41bbb133.svg";